<div class="row influencer-preview-container" [ngClass]="{'odd': !evenRow, 'even': evenRow}">
  <div class="col-md-12">
    <div>
      <div class="row">
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-6 no-padding">
          <div class="d-flex flex-row full-height">
            <a class="d-flex flex-row influencer-data-container align-items-center" style="display: block">
              <div class="post-image-box">
                <div class="oona-post-image-container">
                  <blurry-backdrop-image class="post-img" [image]="post.image" (afterLoaded)="onLoadedImage()"></blurry-backdrop-image>
                  <a class="external-link" href="{{post.url}}" target="_blank" placement="bottom" ngbTooltip="{{'info_box.measure.view_post_page' | translate}}">
                    <img class="icon-external" src="assets/images/External_Link.png"/>
                  </a>
                </div>
              </div>
              <div class="user-summarize d-flex flex-column justify-content-center">
                <a [routerLink]="['/post']"
                   [queryParams]="{influencerId: post.influencerId, urlHash: post.urlHash, activeAccount: activeAccount}" target="_blank"
                   class="preview-influencer-name">{{post.title}}</a>
                <div class="d-flex flex-column">
                  <div class="d-flex flex-row align-items-center sub-preview-data">
                    <a [routerLink]="['/influencer/' + post.influencerId + '/overview']" [queryParams]="{activeAccount: activeAccount}" target="_blank"
                       class="preview-influencer-title">{{post.influencerName}}</a>
                    <span class="left-seperate-line"></span>
                    <span class="preview-influencer-title ellipsis">{{post.publishedDate | date:'dd MMM yyyy'}}</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <a style="display: block" class="col-xl-5 col-lg-6 col-md-6 col-sm-6">
          <div class="row">
            <div class="col-lg-8 col-md-7 col-sm-6">
              <div class="list-platform d-flex flex-row justify-content-end align-items-center full-height preview-post-platforms" >
                <div class="d-flex flex-row justify-content-end">
                  <div class="icon-display">
                    <div class="{{platformName(post.platform) + '-icon lg-icon preview-post-icon'}}"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-5 col-sm-6">
              <div class="d-flex justify-content-end mr-2">
                <div class="influencer-number-wrapper justify-content-center d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="influencer-info-wrapper top left influencer-number-info d-flex flex-column">
                      <div class="number-title d-flex justify-content-end">{{'oona_report_kpi.reach' | translate}}</div>
                      <div class="number-data d-flex justify-content-end"
                           placement="bottom"
                           ngbTooltip="{{'info_box.measure.pb_reach' | translate}}">
                        {{post.reach | thousandNumberSuffix}}
                      </div>
                    </div>
                    <div class="influencer-info-wrapper top right d-flex flex-column">
                      <div class="number-title d-flex justify-content-start">{{'oona_report_kpi.average' | translate}}</div>
                      <div class="number-data d-flex justify-content-start"
                           placement="bottom"
                           ngbTooltip="{{'info_box.measure.pb_avg' | translate}}">
                        {{post.reachAverage | thousandNumberSuffix}}
                      </div>
                    </div>
                  </div>
                  <div class="seperate-influencer-line"></div>
                  <div class="d-flex flex-row">
                    <div class="influencer-info-wrapper bottom left influencer-number-info d-flex flex-column justify-content-end">
                      <div class="number-title d-flex justify-content-end">{{'oona_report_kpi.interaction' | translate}}</div>
                      <div class="number-data d-flex justify-content-end"
                           placement="bottom"
                           ngbTooltip="{{'info_box.measure.pb_enagagement' | translate}}">
                        {{post.interaction | formatInteractionNumber:post.authorized:post.story}}
                      </div>
                    </div>
                    <div class="influencer-info-wrapper bottom right d-flex flex-column">
                      <div class="number-title d-flex justify-content-start">{{'oona_report_kpi.average' | translate}}</div>
                      <div class="number-data d-flex justify-content-start"
                           placement="bottom"
                           ngbTooltip="{{'info_box.measure.pb_interaction' | translate}}">
                        {{post.interactionAverage | thousandNumberSuffix}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="index-number">
                    <achoo-index-status [value]="reachIndex" [status]="getIndexStatus(post.reachIndex)"></achoo-index-status>
                  </div>
                  <div class="index-number">
                    <achoo-index-status [value]="interactionIndex" [status]="getIndexStatus(post.interactionIndex)"></achoo-index-status>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/oona-report/oona-report-item/oona-report-item.component.html